var map = {
	"./404.svg": 4235,
	"./android.svg": 4806,
	"./api.svg": 1147,
	"./company.svg": 3734,
	"./customization.svg": 1672,
	"./develop.svg": 4852,
	"./fast.svg": 5047,
	"./global.svg": 3240,
	"./keyboard.svg": 1414,
	"./linux.svg": 2577,
	"./mail.svg": 636,
	"./media.svg": 7967,
	"./ok.svg": 3655,
	"./os.svg": 6799,
	"./seo.svg": 7184,
	"./use.svg": 8990,
	"./user.svg": 8848
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2922;